import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CardPreview from '../common/CardPreview';
const PortfolioCard = () => {
    return (_jsx(CardPreview, { icon: "faBriefcase", description: "Selected builds with live demos and code.", title: _jsxs(_Fragment, { children: [_jsx("span", { className: "text-text-primary", children: "My" }), '\u00A0', _jsx("span", { className: "text-text-accent", children: "Portfolio" })] }) }));
};
export default PortfolioCard;
